import { useEffect } from 'react';

/**
 * used to manually throw when rendered inside of an ErrorBoundary.
 * this is useful for when the error is defined adjacent or in the same component
 * that the error boundary is being rendered in.
 *
 * example:
 *
 * const error = new Error('test');
 *
 * return (
 * <ErrorBoundary>
 *   <ErrorBoundaryTrigger error={error} />
 *   <div>
 *     {error.message}
 *   </div>
 * </ErrorBoundary>
 * )
 */
export const ErrorBoundaryTrigger = ({
  error
}) => {
  useEffect(() => {
    if (error) {
      throw error;
    }
  }, [error]);
  return null;
};